


































































































































































































































import { Component, Vue, Mixins } from 'vue-property-decorator';

// Mixins
import ThankYouSubmissionMixin from '@/mixins/Claims/ThankYouSubmission';

// Components
import Welcome from '@/components/Global/Welcome.vue';

@Component({
	name: 'PageClaimThankYou',
	components: {
		Welcome,
	},
})
export default class ClaimsThankYou extends Mixins(ThankYouSubmissionMixin) {}
